import Api from "../../api.js";

export const getData = async (url) => {
    return (await Api(url))?.data
}
